(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/wallet/assets/javascripts/wallet-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/wallet/assets/javascripts/wallet-reducer.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _RTK = RTK,
  createReducer = _RTK.createReducer;
const _svs$components$tipse = svs.components.tipsen.wallet.actions,
  updatePlayerWalletBalance = _svs$components$tipse.updatePlayerWalletBalance,
  setActiveWallet = _svs$components$tipse.setActiveWallet,
  fetchPlayerWallet = _svs$components$tipse.fetchPlayerWallet,
  fetchMarketplacePlayerWallets = _svs$components$tipse.fetchMarketplacePlayerWallets,
  fetchMarketplaceRetailWallet = _svs$components$tipse.fetchMarketplaceRetailWallet,
  setRetailerCommission = _svs$components$tipse.setRetailerCommission,
  updateMarketplaceWallet = _svs$components$tipse.updateMarketplaceWallet,
  removeMarketplaceWallet = _svs$components$tipse.removeMarketplaceWallet;
const _svs$components$tipse2 = svs.components.tipsen.wallet.walletType,
  WALLET_PLAYER = _svs$components$tipse2.WALLET_PLAYER,
  WALLET_MARKETPLACE_PLAYER = _svs$components$tipse2.WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER = _svs$components$tipse2.WALLET_MARKETPLACE_RETAILER,
  WALLET_SELFSERVICE = _svs$components$tipse2.WALLET_SELFSERVICE;
const _svs$components$tipse3 = svs.components.tipsen.wallet.walletId,
  WALLET_ID_PLAYER = _svs$components$tipse3.WALLET_ID_PLAYER,
  WALLET_ID_MARKETPLACE_RETAILER = _svs$components$tipse3.WALLET_ID_MARKETPLACE_RETAILER,
  WALLET_ID_SELFSERVICE = _svs$components$tipse3.WALLET_ID_SELFSERVICE;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const initialState = {
  wallets: {},
  activeWallet: null,
  requests: {}
};
if (isSelfService) {
  initialState.wallets[WALLET_ID_SELFSERVICE] = {
    id: WALLET_ID_SELFSERVICE,
    type: WALLET_SELFSERVICE,
    label: 'Självservice',
    meta: {
      balance: 0
    }
  };
  initialState.activeWallet = WALLET_ID_SELFSERVICE;
}
function isPendingWalletAction(action) {
  return action.type.startsWith('wallet/') && action.type.endsWith('/pending');
}
function isRejectedWalletAction(action) {
  return action.type.startsWith('wallet/') && action.type.endsWith('/rejected');
}
const walletReducer = createReducer(initialState, builder => {
  builder.addCase(updatePlayerWalletBalance, (state, action) => {
    var _state$wallets$WALLET;
    if ((_state$wallets$WALLET = state.wallets[WALLET_ID_PLAYER]) !== null && _state$wallets$WALLET !== void 0 && (_state$wallets$WALLET = _state$wallets$WALLET.meta) !== null && _state$wallets$WALLET !== void 0 && _state$wallets$WALLET.balance) {
      state.wallets[WALLET_ID_PLAYER].meta.balance = action.payload;
    }
  }).addCase(fetchPlayerWallet.fulfilled, (state, action) => {
    delete state.requests[action.meta.requestId];
    state.wallets[WALLET_ID_PLAYER] = {
      id: WALLET_ID_PLAYER,
      type: WALLET_PLAYER,
      label: 'Min spelkassa',
      meta: {
        balance: action.payload
      }
    };
  }).addCase(setActiveWallet, (state, action) => {
    state.activeWallet = action.payload;
  }).addCase(updateMarketplaceWallet, (state, action) => {
    const _action$payload = action.payload,
      activatedDrawId = _action$payload.activatedDrawId,
      balance = _action$payload.balance,
      commissionPercent = _action$payload.commissionPercent,
      soldShares = _action$payload.soldShares;
    if (state.wallets[activatedDrawId] && state.wallets[activatedDrawId].type === WALLET_MARKETPLACE_PLAYER) {
      state.wallets[activatedDrawId].meta.balance = balance;
    }
    if (state.wallets[WALLET_ID_MARKETPLACE_RETAILER]) {
      var _state$wallets$WALLET2, _state$wallets$WALLET3;
      const currentCommission = (_state$wallets$WALLET2 = state.wallets[WALLET_ID_MARKETPLACE_RETAILER]) === null || _state$wallets$WALLET2 === void 0 ? void 0 : _state$wallets$WALLET2.meta.commissionPercent;
      Object.assign((_state$wallets$WALLET3 = state.wallets[WALLET_ID_MARKETPLACE_RETAILER]) === null || _state$wallets$WALLET3 === void 0 ? void 0 : _state$wallets$WALLET3.meta, {
        apiCommission: commissionPercent,
        commissionPercent: typeof currentCommission === 'number' ? Math.min(currentCommission, commissionPercent) : commissionPercent,
        currentPlayableAmount: balance,
        soldShares
      });
    }
  }).addCase(removeMarketplaceWallet, state => {
    const walletKey = state.activeWallet;
    if (state.wallets[state.activeWallet]) {
      delete state.wallets[walletKey];
    }
    if (String(state.activeWallet) === walletKey) {
      state.activeWallet = null;
    }
  }).addCase(fetchMarketplacePlayerWallets.fulfilled, (state, action) => {
    delete state.requests[action.meta.requestId];
    Object.entries(state.wallets).forEach(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        walletId = _ref2[0],
        wallet = _ref2[1];
      if (wallet.type === WALLET_MARKETPLACE_PLAYER) {
        delete state.wallets[walletId];
      }
    });
    for (const wallet of action.payload) {
      state.wallets[wallet.activatedDrawId] = {
        id: wallet.activatedDrawId,
        type: WALLET_MARKETPLACE_PLAYER,
        label: wallet.GroupName,
        meta: _objectSpread(_objectSpread({}, wallet), {}, {
          oneTimeUse: true
        })
      };
    }
  }).addCase(fetchMarketplaceRetailWallet.fulfilled, (state, action) => {
    var _state$wallets$WALLET4;
    delete state.requests[action.meta.requestId];
    const currentCommission = (_state$wallets$WALLET4 = state.wallets[WALLET_ID_MARKETPLACE_RETAILER]) === null || _state$wallets$WALLET4 === void 0 ? void 0 : _state$wallets$WALLET4.meta.commissionPercent;
    state.wallets[WALLET_ID_MARKETPLACE_RETAILER] = {
      id: WALLET_ID_MARKETPLACE_RETAILER,
      type: WALLET_MARKETPLACE_RETAILER,
      label: action.payload.name,
      meta: _objectSpread(_objectSpread({}, action.payload), {}, {
        commissionPercent: typeof currentCommission === 'number' ? Math.min(currentCommission, action.payload.commissionPercent) : action.payload.commissionPercent,
        apiCommission: action.payload.commissionPercent,
        oneTimeUse: true
      })
    };
  }).addCase(setRetailerCommission, (state, action) => {
    const _action$payload2 = action.payload,
      walletId = _action$payload2.walletId,
      commission = _action$payload2.commission;
    state.wallets[walletId].meta.commissionPercent = commission;
  }).addMatcher(isPendingWalletAction, (state, action) => {
    state.requests[action.meta.requestId] = action.meta.requestStatus;
  }).addMatcher(isRejectedWalletAction, (state, action) => {
    delete state.requests[action.meta.requestId];
  });
});
setGlobal('svs.components.tipsen.wallet.walletReducer', walletReducer);

 })(window);